"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _switchModule = _interopRequireDefault(require("./switch.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Switch = function Switch(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      disabled = _ref.disabled,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      onChange = _ref.onChange;
  return /*#__PURE__*/_react["default"].createElement("label", {
    className: (0, _classnames["default"])(_switchModule["default"]["switch"], className)
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: _switchModule["default"].inputElement,
    type: "checkbox",
    disabled: disabled,
    checked: checked,
    onChange: (0, _react.useCallback)(function () {
      if (!disabled) {
        onChange(!checked);
      }
    }, [checked, disabled, onChange])
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_switchModule["default"].slider, _switchModule["default"].round)
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_switchModule["default"].label, {
      'sr-only': hideLabel
    })
  }, label));
};

Switch.propTypes = {
  className: _propTypes["default"].string,
  checked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  label: _propTypes["default"].node,
  hideLabel: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};

var noop = function noop() {};

Switch.defaultProps = {
  className: '',
  checked: false,
  disabled: false,
  label: '',
  hideLabel: false,
  onChange: noop
};
var _default = Switch;
exports["default"] = _default;